import { FieldState, FormState } from 'formstate';

import {
    CallType,
    Carrier,
    DialpadNumberAssignmentTarget,
    PhoneNumberModel,
    TcrUseCase,
    TollFreeNumberVerificationStatus,
} from '@servicetitan/application-data/telecom';
import { FormValidators } from '@servicetitan/form';
import { PossibleFormState } from '@servicetitan/table';

const validator = (val: number | undefined, form: PossibleFormState<PhoneNumberModel>) => {
    if (form.$.isDirectDial.value && !val) {
        return 'User is required';
    }
};

export function getPhoneNumberFormState() {
    const form = new FormState({
        phoneNumber: new FieldState<string | undefined>(undefined),
        friendlyName: new FieldState<string | undefined>(undefined),
        localUserId: new FieldState<number | undefined>(undefined),
        isDirectDial: new FieldState(false),
        forwardTo: new FieldState<string | undefined>(undefined).validators(
            FormValidators.required
        ),
        useDefaultCallForwarding: new FieldState(false),
        dateAdded: new FieldState(new Date()),
        addedBy: new FieldState<string | undefined>(undefined),
        isTollFree: new FieldState(false),
        enableSms: new FieldState(true),
        campaignId: new FieldState<number | undefined>(undefined),
        alias: new FieldState<string | undefined>(undefined),
        defaultCallType: new FieldState<CallType | undefined>(undefined),
        isDniAllocated: new FieldState(false),
        isRecordingEnabled: new FieldState(false),
        assignmentTarget: new FieldState<DialpadNumberAssignmentTarget | undefined>(undefined),
        carrier: new FieldState<Carrier>(Carrier.Unknown),
        tollFreeNumberVerificationStatus: new FieldState<
            TollFreeNumberVerificationStatus | undefined
        >(undefined),
        tcrUseCases: new FieldState<TcrUseCase[] | undefined>(undefined),
        tcrCampaignId: new FieldState<number | undefined>(undefined),
        tcrCampaignExternalId: new FieldState<string | undefined>(undefined),
    });

    form.$.localUserId.validators((val: number | undefined) => validator(val, form));

    return form;
}
